import './create-search-card-view';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { CreateSearchResult } from './interfaces/create-search.interface';
import { ProductCardData } from '../../product-card/product-card-display';
import { StoreState } from '../../../store/store.interface';
import { connect } from 'pwa-helpers';
import { customElement, state } from 'lit/decorators.js';
import { html, nothing, TemplateResult } from 'lit';
import { mapCreateProductCardData } from './mapping/create-search-product-card.mapping';
import { selectCreateRequest, selectCreateResults } from './store/create-search.selector';

@customElement('mhecomm-create-search-results')
export class CreateSearchResultsView extends connect(store)(BaseComponent) {
  /**
   * The product cards to display.
   */
  @state()
  private productCards: ProductCardData[] = [];

  /**
   * The Create search results retrieved from Redux.
   */
  @state()
  private results: CreateSearchResult[] = [];

  /**
   * The store retrieved from the Create search request.
   */
  @state()
  private store?: string;

  stateChanged(state: StoreState): void {
    const request = selectCreateRequest(state);
    const results = selectCreateResults(state) || [];
    this.store = request?.store;

    if (this.results !== results) {
      this.results = results;
      this.productCards = mapCreateProductCardData(this.results);
    }
  }

  renderComp(): TemplateResult {
    return html`
      <div id="create-search-results" tabindex="-1" role="region" aria-label="Results">
        ${this.productCards?.length > 0 ? this.getResults() : nothing}
      </div>
    `;
  }

  private getResults(): TemplateResult {
    return html`
      ${this.productCards.map(
        (product, index) => html`
          <mhecomm-create-search-card-view .product="${product}" .productIndex="${index}" .store="${this.store}">
          </mhecomm-create-search-card-view>
        `
      )}
    `;
  }

  scrollToResult(): void {
    const stickyTopElementHeight = document.querySelector('.sticky-top')?.clientHeight;
    if (stickyTopElementHeight) {
      window.scrollTo({
        top: stickyTopElementHeight,
        behavior: 'smooth',
      });
    } else {
      this.scrollTo();
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-create-search-results': CreateSearchResultsView;
  }
}
